import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Grid, Typography, Box } from "@mui/material";
import { query, collection, where, getDocs } from "firebase/firestore";
import qs from "query-string";

import { cmsDb } from "../../firebase";

import QuizView from "./QuizView";
import SplashScreen from "../../components/SplashScreen";
import UserInfoModal from "./components/UserInfoModal";
import Icon from "../../components/Icon";

const org = "UK Care";

export const sectionKeys = [
  { key: "budgeting", value: "budgeting", label: "Budgeting" },
  { key: "debts", value: "debts", label: "Debt Management" },
  { key: "pay", value: "pay", label: "Pay & Allowances" },
  { key: "homeowner", value: "home", label: "Your Home" },
  { key: "health", value: "health", label: "Your Health" },
  { key: "pensions", value: "pensions", label: "Penions & Savings" },
  { key: "planning", value: "planning", label: "Later Life Planning" },
];

export default function Wrapper() {
  const [config, setConfig] = useState();
  const [sections, setSections] = useState();
  const [overall, setOverall] = useState();
  const [scoring, setScoring] = useState();

  const [selectedSection, setSelectedSection] = useState("");
  const [showUserInfoModal, setShowUserInfoModal] = useState(false);

  const location = useLocation();

  const getQuiz = async (org) => {
    const q = query(
      collection(cmsDb, "questionsets"),
      where("name", "==", org)
    );
    const found = await getDocs(q);
    found.forEach((f) => {
      setConfig(f.data());
    });
  };

  useEffect(() => {
    getQuiz(org);
  }, [org]);

  useEffect(() => {
    if (config) {
      const { questionData, overall, scoring } = config;
      const ns = { ...questionData };
      for (const s of Object.keys(ns)) {
        ns[s].title = ns[s].title.split("-")[1];
      }
      setSections(ns);
      setOverall(overall);
      setScoring(scoring);

      if (qs.parse(location.search)?.s) {
        localStorage.removeItem("fullQuiz");
        setSelectedSection(qs.parse(location.search).s);
      } else {
        setSelectedSection("budgeting");
        localStorage.setItem("fullQuiz", 1);
      }
    }
  }, [config]);

  useEffect(() => {
    const storedSession = localStorage.getItem("userInfo");
    if (!storedSession) {
      setShowUserInfoModal(true);
    }
  }, [selectedSection]);

  if (!sections && !overall) {
    return <SplashScreen />;
  }

  if (!selectedSection) {
    return (
      <>
        <Grid item xs={12}>
          <Typography variant="h4" fontWeight="bold" color="primary.main" p={5}>
            I want to complete a Financial Assessment about my...
          </Typography>
        </Grid>
        <SelectASection setSelectedSection={setSelectedSection} />
        <Typography p={2}>or</Typography>
        <Typography
          sx={{
            fontWeight: "bold",
            p: 4,
            display: "inline-block",
            color: "primary.main",
            transition: "1s ease-out",
            cursor: "pointer",
            "&:hover": {
              position: "relative",
              transform: "translateY(-5%)",
              background: "whitesmoke",
            },
          }}
          onClick={() => {
            setSelectedSection("budgeting");
            localStorage.setItem("fullQuiz", 1);
          }}
        >
          Complete All Sections
        </Typography>
      </>
    );
  }

  return (
    <>
      {showUserInfoModal ? (
        <UserInfoModal setOpen={setShowUserInfoModal} />
      ) : (
        <QuizView
          scoring={scoring}
          sections={sections}
          overall={overall}
          startSection={selectedSection}
        />
      )}
    </>
  );
}

export const SelectASection = ({ setSelectedSection, useLinks }) => {
  return (
    <Grid
      container
      sx={{
        maxWidth: "800px",
        margin: "auto",
        justifyContent: "center",
      }}
    >
      {sectionKeys.map((s, idx) => {
        return (
          // <motion.li key={idx} variants={item} />
          <Grid item xs={12} md={3}>
            <a
              style={{
                textDecoration: "none",
              }}
              target="_blank"
              href={
                useLinks
                  ? `https://ukcareguide.co.uk/financial-assessment-${
                      s.key === "homeowner" ? "home" : s.key
                    }/`
                  : ""
              }
            >
              <Box
                onClick={() => {
                  if (useLinks) return;
                  setSelectedSection(s.key);
                  localStorage.removeItem("fullQuiz");
                }}
                sx={{
                  cursor: "pointer",
                  borderRadius: "10px",
                  transition: "1s ease-out",
                  "&:hover": {
                    position: "relative",
                    transform: "translateY(-5%)",
                    background: "whitesmoke",
                  },
                  p: 2,
                }}
              >
                <Icon section={s.key} s=" border-radius: 20px;" />
                <Typography color="primary.main" fontWeight="bold" py={2}>
                  {s.label}
                </Typography>
              </Box>
            </a>
          </Grid>
        );
      })}
    </Grid>
  );
};
